import { Sidebar as PrimeSidebar } from 'primereact/sidebar'
import { useTranslation } from 'react-i18next'
import NavMenu from '../nav/NavMenu'

interface MobileDrawerProps {
  visible: boolean
  onHide: () => void
}

/** Dar ekran (mobil) açılır-kapanır menü paneli. */
export default function MobileDrawer({ visible, onHide }: MobileDrawerProps) {
  const { t } = useTranslation()
  return (
    <PrimeSidebar visible={visible} onHide={onHide} className="sidebar mobile-drawer">
      <div className="brand">
        {/* Koyu sidebar zemininde siyah metinli logo okunmuyor → beyaz metinli varyant. */}
        <img className="brand-logo" src="/tk-seyir-logo-light.png" alt={t('shell.brand.title')} />
      </div>
      <NavMenu collapsed={false} onNavigate={onHide} />
    </PrimeSidebar>
  )
}
